import $ from 'jquery';
import attachEnterAsClick from 'utils/attachEnterAsClick';

const engagementVideoInit = (index, component) => {
    const hiddenClass = 'is-hidden';
    const visibleClass = 'is-visible';

    const videoPlayerSelector = '.video-player';
    const videoContentSelector = '.video-content';
    const videoEmbedSelector = '.c-video-embed';
    const playSelector = '.btn-play';
    const closeSelector = '.btn-close';

    const $component = $(component);
    const $videoPlayer = $component.find(videoPlayerSelector);
    const $videoContent = $component.find(videoContentSelector);
    const $videoSelector = $component.find(videoEmbedSelector);
    const $iframe = $videoPlayer.find('iframe');

    let isDetached = false;

    // Slide open the video content
    $component.on('click', playSelector, () => {
        // fade out content & bg image
        $videoContent.addClass(hiddenClass);
        $videoPlayer.addClass(visibleClass);

        if (isDetached) {
            // append the iframe to the component
            // if it has been detached by previous close action
            $iframe.appendTo($videoSelector);
        } else {
            // get current video url
            const videoSrc = $iframe.attr('src');
            const queries = videoSrc.split('?');
            let src = `${queries[0]}?autoplay=1`;

            // attach extra params if they exist
            if (queries[1]) {
                src = `${src}&${queries[1]}`;
            }

            // then, show youtube player and autoplay
            $iframe.attr('src', src);
        }
    });

    attachEnterAsClick($(playSelector));

    $component.on('click', closeSelector, () => {
        $videoContent.removeClass(hiddenClass);
        $videoPlayer.removeClass(visibleClass);
        // this is a dirty way to stop the video from playing
        // without having to load and use the youtube iframe api
        $videoPlayer.find('iframe').detach();

        isDetached = true;
    });
    attachEnterAsClick($(closeSelector));
};

$(() => {
    const $widget = $('.s-engagement-video');

    if ($widget.length) {
        $widget.each(engagementVideoInit);
    }
});
